export const BRAND = {
  name: "Maati Organics",
  tagline: "From Earth to Plate",
  whatsapp: {
    number: "+91 8151020101",
    link: "https://wa.me/918151020101",
  },
  instagram: {
    handle: "@maati_organics",
    link: "https://instagram.com/maati_organics",
  },
  logo: "https://customer-assets.emergentagent.com/job_spice-hub-79/artifacts/fhlrzunl_WhatsApp%20Image%202026-04-18%20at%208.13.52%20PM%281%29.jpeg",
};

export const PRODUCTS = [
  {
    slug: "haldi",
    name: "Haldi Powder",
    subtitle: "Golden. Earthy. Hand-pounded.",
    description:
      "Sun-dried turmeric roots, hand-milled in small batches to preserve the curcumin and that warm, grounding aroma every Indian kitchen remembers.",
    label:
      "https://customer-assets.emergentagent.com/job_spice-hub-79/artifacts/s73iod0a_WhatsApp%20Image%202026-04-18%20at%208.13.51%20PM.jpeg",
    accent: "#D99026",
    swatch: "#D99026",
    origin: "Organic farms · Karnataka",
    heat: 0,
    aroma: "Earthy · warm · lightly bitter",
    pairings: ["Doodh", "Daal", "Sabzi", "Golden milk"],
    net: "100 GM",
  },
  {
    slug: "red-chilli",
    name: "Red Chilli Powder",
    subtitle: "Bold. Bright. Slow-sun-dried.",
    description:
      "Byadgi & Guntur chillies, sun-kissed on village courtyards and hand-pounded the traditional way. Deep colour, honest heat — no artificial tint, ever.",
    label:
      "https://customer-assets.emergentagent.com/job_spice-hub-79/artifacts/e7f5b3px_WhatsApp%20Image%202026-04-18%20at%208.13.52%20PM.jpeg",
    accent: "#B33922",
    swatch: "#C0392B",
    origin: "Byadgi · Karnataka",
    heat: 3,
    aroma: "Bright · smoky · deep red",
    pairings: ["Curries", "Tadka", "Marinades", "Pickles"],
    net: "100 GM",
  },
  {
    slug: "masala-chilli",
    name: "Masala Chilli Powder",
    subtitle: "Heirloom blend. 18 unique masalas. One tin.",
    description:
      "Our house blend of 18 unique masalas — red chilli mellowed with coriander, cumin, pepper, cloves, cardamom & more. Roasted, rested, hand-ground to build a flavour that lingers.",
    label:
      "https://customer-assets.emergentagent.com/job_spice-hub-79/artifacts/9j6x3kk6_WhatsApp%20Image%202026-04-18%20at%208.13.50%20PM.jpeg",
    accent: "#8F2B17",
    swatch: "#8F2B17",
    origin: "House blend · Small batch",
    heat: 2,
    aroma: "Complex · toasty · long finish",
    pairings: ["Biryani", "Kebab", "Mutton", "Tawa veg"],
    net: "100 GM",
  },
];
